import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Directory from "@/pages/Directory";
import Embed from "@/pages/Embed";
import Submit from "@/pages/Submit";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, border: "2px solid #000" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Directory />} />
          <Route path="/embed" element={<Embed />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
